module.exports = __webpack_public_path__ + "img/desktop/Background/BG_normal@1x.jpg?1.0.39";


//////////////////
// WEBPACK FOOTER
// ./out/img/desktop/Background/BG_normal@1x.jpg
// module id = 587
// module chunks = 0